<template>
  <div class="site-message">
    <VAlert
      v-if="showAlert"
      class="text-center mx-1 my-1"
      color="error"
      elevation="0"
      closable
      data-testid="site-error-message"
      @click:close="showAlert = false"
    >
      {{ $t(alertMessage) }}
    </VAlert>
    <VAlert
      v-if="showSuccess"
      class="text-center mx-1 my-1"
      color="success"
      elevation="0"
      closable
      data-testid="site-success-message"
      @click:close="showSuccess = false"
    >
      <span class="font-weight-bold">
        {{ $t(successMessage) }}
      </span>
    </VAlert>
  </div>
</template>

<script setup>
import {
  useMessageStore,
} from '@/stores/message'

const messageStore = useMessageStore()

const showAlert = ref(false)
const alertMessage = ref('')
const showSuccess = ref(false)
const successMessage = ref('')

function showAlertMessage(value) {
  alertMessage.value = value
  showAlert.value = true
  setTimeout(() => {
    showAlert.value = false
  }, 4000)
}

function showSuccessMessage(value) {
  successMessage.value = value
  showSuccess.value = true
  setTimeout(() => {
    showSuccess.value = false
  }, 4000)
}

watch(() => messageStore.message.alert, value => {
  if (!value) return
  showAlertMessage(value)
  nextTick(() => {
    messageStore.message.alert = null
  })
})

watch(() => messageStore.message.success, value => {
  if (!value) return
  showSuccessMessage(value)
  nextTick(() => {
    messageStore.message.success = null
  })
})
</script>

<style lang="scss" scoped>
    .site-message {
        position: fixed;
        top: 0;
        z-index: 10000;
        left: 0;
        width: 100%;

        .v-alert{

            .v-alert__underlay {
                opacity: 0 !important;
            }
        }
    }
</style>
